import React from 'react'
import PropTypes from 'prop-types'
import MEModal from '../../components/MEModal'
import { Button } from 'react-bootstrap'

const EditGroupModal = props => {
  return (
    <MEModal
      show={props.modalOpen}
      close={props.openCloseModal}
      title="Edit Assignment Group"
    >
      <div className="text-center mb-4">
        <form onSubmit={e => e.preventDefault()}>
          <div className="mb-3">
            <input
              type="text"
              className="w-50"
              value={props.groupName}
              onChange={props.handleGroupNameInput}
            />
          </div>
          {props.applyGroupWeights ? (
            <div className="mb-3 d-flex justify-content-around">
              <input
                type="number"
                step="1"
                className="form-control form-control-sm w-25 p-1"
                placeholder="Weight (integer)"
                value={props.weight}
                onChange={props.handleWeightInput}
              />
            </div>
          ) : null}
        </form>
        <Button
          type="button"
          disabled={props.groupName === ''}
          bsStyle="danger"
          className="btn-myed btn-danger-myed mr-4"
          onClick={props.editGroup}
        >
          Save
        </Button>
        <Button
          type="button"
          bsStyle="default"
          className="btn-myed btn-default-myed"
          onClick={props.openCloseModal}
        >
          Cancel
        </Button>
      </div>
    </MEModal>
  )
}

EditGroupModal.propTypes = {
  modalOpen: PropTypes.bool,
  openCloseModal: PropTypes.func,
  groupName: PropTypes.string,
  handleGroupNameInput: PropTypes.func,
  applyGroupWeights: PropTypes.bool,
  handleWeightInput: PropTypes.func,
  editGroup: PropTypes.func,
  weight: PropTypes.number,
}

export default EditGroupModal
